/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { Component } from 'react';
import { confirmWrapper } from 'src/components/Dialog';
import withRouter from '../../hooks/withRouter';

import {
  CreateInterviewSlotsRequest,
  FetchMonthSlotsRequest,
  HighlightedDaysRequest,
  InterviewSlotsProps,
  InterviewSlotsState,
  InterviewSlotsViewRendererProps,
  RescheduleInterviewRequest,
} from './types';

import ViewRenderer from './views';

import API from '../../network';
import RescheduleInterviewPopup from './components/RescheduleInterviewPopup';

class InterviewSlots extends Component<
InterviewSlotsProps,
InterviewSlotsState
> {
  constructor(props: InterviewSlotsProps) {
    super(props);

    this.state = {
      isCalendarLoading: false,
      highlightedDays: [],
      monthSlots: {},
      allSlots: {
        OPEN: {},
        RESERVED: {},
      },
    };
  }

  componentDidMount(): void {
    this.getAllSlots();
  }

  getSlotsByMonth = async (data: HighlightedDaysRequest) => {
    const { month, year, interviewerId } = data;
    try {
      const finalData: FetchMonthSlotsRequest = {
        month: month + 1,
        year,
        statuses: ['OPEN', 'RESERVED'],
        interviewerId,
      };
      const fetchedSlots = await API.getInstance().getMonthSlots(finalData);

      // Object.keys(fetchedSlots).length === 0

      // Extract the keys (dates) and create the highlightedDays array
      const highlightedDays = (fetchedSlots?.OPEN)
        ? Object.keys(fetchedSlots?.OPEN).map((date) => ({
          date,
          slots: fetchedSlots?.OPEN[date].length,
        })) : [];

      this.setState({
        monthSlots: fetchedSlots.OPEN,
        highlightedDays,
      });
    } catch (err) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    }
  };

  saveInterviewSlots = async (data: CreateInterviewSlotsRequest) => {
    try {
      await API.getInstance().createInterviewSlots(data);
      const message = 'Interview slots created successfully!';
      await confirmWrapper(message, {
        hideSecondaryBtn: true,
        hidePrimaryBtn: true,
        variant: 'success',
        autoClose: true,
      });
      this.getAllSlots();
    } catch (err) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    } finally {
      this.setState({
        isCalendarLoading: false,
      });
    }
  };

  deleteInterviewSlot = async (slotId: number) => {
    const confirmation = await confirmWrapper(
      'Are you sure you want to delete the slot?',
      {
        variant: 'warning',
        primaryBtnLabel: 'Proceed',
        secondaryBtnLabel: 'Cancel',
      },
    );
    if (confirmation) {
      try {
        await API.getInstance().deleteInterviewSlots(slotId);
        const message = 'Interview slot deleted successfully!';
        await confirmWrapper(message, {
          hideSecondaryBtn: true,
          hidePrimaryBtn: true,
          variant: 'success',
          autoClose: true,
        });
        this.getAllSlots();
      } catch (err) {
        await confirmWrapper('Something went wrong', {
          hideSecondaryBtn: true,
          variant: 'danger',
        });
      } finally {
        this.setState({
          isCalendarLoading: false,
        });
      }
    }
  };

  getAllSlots = async () => {
    try {
      const fetchedSlots = await API.getInstance().getAllSlots();
      this.setState({
        allSlots: fetchedSlots,
      });
    } catch (err) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    }
  };

  rescheduleInterviewSlot = async (
    data: RescheduleInterviewRequest,
    close: (() => void) | undefined,
  ):Promise<void> => {
    try {
      await API.getInstance().rescheduleInterviewSlot(data);
      const message = 'Interview slot rescheduled successfully!';
      await confirmWrapper(message, {
        hideSecondaryBtn: true,
        hidePrimaryBtn: true,
        variant: 'success',
        autoClose: true,
      });
      this.getAllSlots();
      if (close) close();
    } catch (err) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    }
  };

  showReschedulePopup = (id: number) => {
    confirmWrapper('', {
      variant: '',
      hidePrimaryBtn: true,
      hideSecondaryBtn: true,
      maxWidth: 'md',
      fullWidth: true,
      containerClasses: 'p-0 px-10',
      showCloseButton: true,
      disableBackdropClickClose: true,
      disableEscapeKeyDownClose: true,
      dialogContent: (
        <RescheduleInterviewPopup
          id={id}
          rescheduleInterviewSlot={this.rescheduleInterviewSlot}
        />
      ),
    });
  };

  getProps = (): InterviewSlotsViewRendererProps => {
    const {
      highlightedDays, isCalendarLoading, monthSlots, allSlots,
    } = this.state;

    return {
      highlightedDays,
      isCalendarLoading,
      monthSlots,
      allSlots,
      getSlotsByMonth: this.getSlotsByMonth,
      saveInterviewSlots: this.saveInterviewSlots,
      deleteInterviewSlot: this.deleteInterviewSlot,
      showReschedulePopup: this.showReschedulePopup,
    };
  };

  render() {
    const viewProps: InterviewSlotsViewRendererProps = this.getProps();

    return <ViewRenderer {...viewProps} />;
  }
}

export default withRouter(InterviewSlots);
